import request from "@/utils/request";
// import qs from "qs";
/**
 * @description 获取首页招采列表
 * @param {*} data
 */
export function getPurchase(data) {
  return request({
    url: "/trade/api/home/purchase/list",
    method: "get",
    params: data,
  });
}

/**
 * @description 获取首页采购列表
 * @param {*} data
 */
export function getBuyList(data) {
  return request({
    url: "/trade/api/home/buy/list",
    method: "get",
    params: data,
  });
}
